import { useState, useEffect } from 'react';
import DiagramIDE from './DiagramIDE';
import { Button } from 'beautiful-react-ui';
import compile from '../compiler/Compiler';
import { Program } from '../compiler/Program';
import Runtime from '../runtime/Runtime';
import Precompiler from './Precompiler';
import { SchemaSerializor } from '../serializor/SchemaSerializor';
import { TeaBlocksError } from '../compiler/TeaBlocksError';
import '../styles/Ide.scss';
import ReactDOM from 'react-dom';

import bouncyProgram from '../demoContent/bouncy-program.json';
import joystickProgram from '../demoContent/joystick-program.json';
import Information from '../demoContent/Information';

const ideId = 'ide';
const emptyProgram = new Program([], new Map());

let canShowPopup = false;

/**
 * The react component containing the IDE of the TeaBlocks app. This class
 * encapsulates DiagramIDE.
 */
export default function AppDiagram() {
    const [program, setProgram] = useState<Program>(emptyProgram);
    const [popOpen, setPopOpen] = useState(false);

    useEffect(() => {
        DiagramIDE.getIDE().renderDiagram();
    }, []);

    useEffect(() => {
        let rtElem = document.getElementById('Runtime');
        if (rtElem) {
            console.log('UNMOUNTING RUNTIME');
            ReactDOM.unmountComponentAtNode(rtElem);
        }

        if (program !== emptyProgram) {
            console.log('MOUNTING RUNTIME');
            ReactDOM.render((
                <Runtime program={program} />
            ), document.getElementById('Runtime'));
        }

        return () => {
            console.log('Cleanup?')
            program.stop();
        }
    }, [program])

    function build() {
        console.log('Button compile and run');
        DiagramIDE.getIDE().unflagNodes();

        let precomp = Precompiler.precompile(DiagramIDE.getIDE().validatedSchemas);
        canShowPopup = true;
        compile(precomp).then(prog => {
            prog.errorNotify = errorNotify;
            setProgram(prog);
        }).catch(err => {
            console.error(err);
        })
    }

    function runProg() {
        program.varEnv.set('&joy-joystick', { x: 0, y: 0 }); //! remove later

        console.log('Run Program');

        try {
            program.run();
        } catch (err) {
            if (err instanceof TeaBlocksError) {
                console.error(err);
                DiagramIDE.getIDE().flagNodes(err.id);
            } else {
                throw err;
            }
        }
    }

    function errorNotify(message: string, ...nodeId: string[]): void {
        DiagramIDE.getIDE().flagNodes(...nodeId);
        DiagramIDE.getIDE().redrawDiagram();
    }

    function goHome() {
        DiagramIDE.getIDE().setDisplaySchemaId('main');
    }

    // function load() {
    //     let json = prompt('Paste the JSON for validatedSchemas:', '');
    //     let [val, nID] = SchemaSerializor.deserialize(json ? json : '');
    //     DiagramIDE.getIDE().loadSchemas(val, nID);
    // }

    // ! temporary for demo files
    function loadBouncy() {
        let stringified = JSON.stringify(bouncyProgram);
        let [val, nID] = SchemaSerializor.deserialize(stringified ? stringified : '');
        DiagramIDE.getIDE().loadSchemas(val, nID);
    }

    function loadJoystick() {
        let stringified = JSON.stringify(joystickProgram);
        let [val, nID] = SchemaSerializor.deserialize(stringified ? stringified : '');
        DiagramIDE.getIDE().loadSchemas(val, nID);
    }

    function togglePopup() {
        setPopOpen(!popOpen);
    }



    return (
        <div className="grid-container">
            <div className="Ide">
                <div id={ideId} />
                <Button color="primary" icon="home" onClick={goHome} className="compile-btn"> Go to Main</Button>
                <Button color="primary" icon="hammer" onClick={() => { build() }} className="compile-btn"> Build</Button>
                <Button color="primary" icon="play" onClick={() => runProg()} className="compile-btn"> Run</Button>
                <Button color="primary" icon="stop" onClick={program.stop} className="compile-btn"> Stop</Button>
                {canShowPopup && <Button color="primary" icon="question" onClick={togglePopup} className="compile-btn help">Help</Button>}
                {/* <Button color="primary" icon="save" onClick={() => { console.log(SchemaSerializor.serialize()) }} className="compile-btn"> Save</Button> */}
                {/* <Button color="primary" icon="upload" onClick={load} className="compile-btn"> Load</Button> */}
            </div>
            <div className="Runtime" id="Runtime">
                <Information loadBouncy={loadBouncy} loadJoystick={loadJoystick} />
            </div>
            {popOpen && <div className="info-popup">
                <Information loadBouncy={loadBouncy} loadJoystick={loadJoystick} />
                <button onClick={togglePopup} className="close-btn">X</button>
            </div>}
            
        </div>
    )
}
